export class AzureDisk {
    'providerDiskId';
    'settings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "AzureDiskSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDisk.attributeTypeMap;
    }
    constructor() {
    }
}
